


















































































import { Component, Ref, Vue, Watch, Prop } from 'vue-property-decorator'
import Candidate from '@/evaluations/entities/candidate'
import Evaluation from '@/evaluations/entities/evaluation'
import candidateService from '@/evaluations/services/candidate-service'
import evaluationService from '@/evaluations/services/evaluation-service'
import { isDraft, isInProgress } from '@/evaluations/utils/evaluation-states'
import RatingListCandidate from '@/evaluations/entities/rating-list-candidate'

@Component
export default class RatingList extends Vue {
  @Prop()
  private eId!: string
  @Prop()
  private jId!: string

  private loading = false

  private evaluation: Evaluation = new Evaluation()
  private candidates: RatingListCandidate[] = []

  private get isDraft() {
    return isDraft(this.evaluation.status)
  }

  private get isInProgress() {
    return isInProgress(this.evaluation.status)
  }

  private get evaluationCompleted() {
    var completed = true
    this.candidates.forEach(element => {
      if (element.numOfCompetences != element.numOfRatings) {
        completed = false
      }
    })

    return completed
  }

  private rate(candidate: Candidate) {
    this.$router.push({
      name: 'ratingcandidate',
      params: {
        lang: this.$i18n.locale,
        eId: this.eId,
        jId: this.jId,
        cId: candidate.id,
      },
    })
  }

  private async loadEvaluationAsync() {
    this.evaluation =
      (await evaluationService.findOneAsync(this.eId)) || new Evaluation()
  }

  private async loadRatingListCandidatesAsync(resetPage = false) {
    this.loading = true
    this.candidates = await candidateService.findRatingListCandidatesAsync(
      this.eId,
      this.jId
    )
    this.candidates.push(new RatingListCandidate())
    this.loading = false
  }

  private async mounted() {
    await this.loadEvaluationAsync()
    await this.loadRatingListCandidatesAsync()
  }
}
